import { useContext } from "react";
import { AuthContext } from "@/contexts/auth-context";
import type { AuthContextType } from "@/types/auth";

export function useAuthContext(): AuthContextType {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuthContext must be used within an AuthProvider");
  }
  return context;
}
